<template>
    <modal
        :saveAction="saveAction"
        :title="title"
        :id="id"
        :actionButtons="false"
        size="lg"
        :closeButton="true"
        @shown="shown()"
        :scrollable="true"
    >
        <template slot="modal-header">
            <span></span>
        </template>

        <div class="row">
            <div class="col">
                <div class="card">
                    <!-- Search -->
                    <div class="row align-items-center">
                        <div class="col-auto pr-0 ml-3">
                            <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                            <span class="fe fe-search text-muted" v-else></span>
                        </div>
                        <div class="col">
                            <!-- <input type="search" class="form-control form-control-flush search no-glow"> -->
                            <b-form-input
                                v-model="query"
                                class="no-glow search form-control-flush"
                                :placeholder="$t('Search')"
                            ></b-form-input>
                        </div>
                        <div class="col-auto">
                            <specialty-select v-model="specialtyQuery" />
                        </div>
                    </div>
                </div>

                <div class="card" v-if="breadcrumbs.length>0">
                    <div class="card-body p-0 pl-4 pr-4">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li
                                    class="breadcrumb-item"
                                    v-for="(item, index) in breadcrumbs"
                                    :key="index"
                                    aria-current="page"
                                >
                                    <a
                                        href="#"
                                        v-if="parentId!=item._id"
                                        @click.prevent="parentId=item._id"
                                    >{{ item.label }}</a>
                                    <span v-else>{{ item.label }}</span>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <div class="card card-inactive" v-if="icd.length==0">
                    <div class="card-body pl-4 pr-4 text-center small text-muted">{{$t('Nothing yet')}}</div>
                </div>
                <ul class="list-group list" v-else>
                    <li class="list-group-item" v-for="(idcItem, index) in icd" :key="index">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <button class="btn btn-sm btn-white ml-2" @click="use(idcItem)">
                                    <i class="fe fe-check"></i>
                                </button>
                            </div>
                            <div class="col-2 pointer" @click="parentId=idcItem._id">{{idcItem.code}}</div>
                            <div class="col ml-n5 pointer" @click="parentId=idcItem._id">
                                <span class="mb-1 name">{{idcItem.label}}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import { icdMixins } from '@/components/ICD10/icd-mixins.js'
import SpecialtySelect from '@/components/SpecialtySelect'


export default {
    name: 'icd-modal',
    props: ['id', 'saveAction', 'data', 'useAction'],
    mixins: [modalMixins, icdMixins],
    components: {
        Modal,
        SpecialtySelect
    },
    data() {
        return {
            query: null,
            breadcrumbs: [],
            specialtyQuery: [],
            parentId: null,
            model: {
                language: 'russian'
            },
            title: 'ICD 10',
        }
    },
    computed: {
        ...mapState('auth', [
            'user'
        ]),
    },


    methods: {
        use(item) {
            this.useAction(JSON.parse(JSON.stringify(item)));
            this.$toasted.global.success({ message: this.$t('Added successfully') });
        },
        getParents(parentId) {
            if (!parentId) return;
            this.get(parentId).then(item => {
                this.breadcrumbs.unshift(item);

                if (item.parentId) {
                    this.getParents(item.parentId);
                } else {
                    this.breadcrumbs.unshift({
                        label: 'Home',
                    });
                }
            });
        },
        shown() {
            /* Switch back to the first tab */
            // this.specialtyQuery = [this.user.specialtyId];
            this.queryItems();
        },
        validation(field) {
            if (this.errors && this.errors[field])
                return false
            else
                return null
        }
    },

}
</script>
<style>
.pre-formatted {
  white-space: pre;
}
</style>
